import React, { JSX } from "react";
import { StyledWrapper, StyledTitle, StyledSubtext } from "./index.styled";

export interface NoResultsProps {
  term: string;
}

export function NoResults({ term }: NoResultsProps): JSX.Element {
  return (
    <StyledWrapper>
      <StyledTitle>We found no results for &apos;{term}&apos;</StyledTitle>
      <StyledSubtext>
        If you can&apos;t find a product, check the spelling, try generic search
        terms or the product number, or consider that it may be discontinued.
      </StyledSubtext>
    </StyledWrapper>
  );
}
